(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocomai-coupons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cocomai-coupons')) {
    customElements.define('cocomai-coupons', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.cc-coupons__track');
        this.cards = [...this.querySelectorAll('.cc-coupons__card')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.nav = this.querySelector('.cc-coupons__nav');
        this.index = 0;
        if (this.nav) this.nav.hidden = false;
        this.addEventListener('click', async event => {
          const copy = event.target.closest('[data-code]');
          if (copy) {
            const status = this.querySelector('[role="status"]');
            try {
              await navigator.clipboard.writeText(copy.dataset.code);
              if (status) status.textContent = status.dataset.success;
              const label = copy.querySelector('.cc-coupons__copy-text');
              if (label) {
                const prev = label.dataset.idle || label.textContent;
                label.dataset.idle = prev;
                label.textContent = '완료';
                copy.classList.add('is-copied');
                clearTimeout(this._copyTimer);
                this._copyTimer = setTimeout(() => { label.textContent = prev; copy.classList.remove('is-copied'); }, 1800);
              }
            } catch { if (status) status.textContent = status.dataset.failure; }
          }
          if (event.target.closest('[data-prev]')) this.go(this.index - 1);
          if (event.target.closest('[data-next]')) this.go(this.index + 1);
          const dot = event.target.closest('[data-dot]');
          if (dot) this.go(this.dots.indexOf(dot));
        }, options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !matchMedia('(max-width:989px)').matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      go(index) {
        if (!matchMedia('(max-width:989px)').matches || !this.cards.length) return;
        index = Math.max(0, Math.min(index, this.cards.length - 1));
        const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - 2;
        this.track.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        if (!this.cards.length || !this.nav) return;
        const left = this.track.getBoundingClientRect().left + 2;
        this.index = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(this.cards[best].getBoundingClientRect().left-left) ? i : best, 0);
        if (this.track.scrollLeft > 1 && this.track.scrollLeft >= this.track.scrollWidth-this.track.clientWidth-3) this.index = this.cards.length-1;
        this.querySelector('[data-prev]').disabled = this.index === 0;
        this.querySelector('[data-next]').disabled = this.index === this.cards.length-1;
        this.querySelector('[data-current]').textContent = this.index+1;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocomai-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cmsrInit) return;
  window.__cmsrInit = true;

  var RECENT_KEY = 'cocomai:recent-searches';
  var MAX_RECENT = 10;
  var openedByHistory = false;
  var closing = false;
  var lastFocused = null;
  var drag = null;

  function root() { return document.getElementById('cocomai-search-root'); }
  function q(sel) { var r = root(); return r ? r.querySelector(sel) : null; }
  function isDesktop() { return window.matchMedia('(min-width: 768px)').matches; }
  function isOpen() { var r = root(); return !!r && !r.hidden && !closing; }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function searchBase() {
    var f = q('[data-cmsr-form]');
    return (f && f.getAttribute('action')) || (window.routes && window.routes.searchUrl) || '/search';
  }
  function searchUrlFor(term) {
    return searchBase() + '?q=' + encodeURIComponent(term) + '&type=product';
  }

  /* ---------- 최근 검색어 (localStorage) ---------- */
  function getRecent() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function setRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT))); } catch (e) {}
  }
  function addRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    var list = getRecent().filter(function (t) { return t !== term; });
    list.unshift(term);
    setRecent(list);
  }
  function removeRecent(term) {
    setRecent(getRecent().filter(function (t) { return t !== term; }));
    renderRecent();
  }
  function clearRecent() { setRecent([]); renderRecent(); }

  function renderRecent() {
    var wrap = q('[data-cmsr-recent]');
    if (!wrap) return;
    var clearBtn = q('[data-cmsr-recent-clear]');
    var list = getRecent();
    if (!list.length) {
      wrap.innerHTML = '<p class="cmsr__empty">최근 검색어가 없습니다.</p>';
      if (clearBtn) clearBtn.hidden = true;
      return;
    }
    if (clearBtn) clearBtn.hidden = false;
    wrap.innerHTML = list.map(function (t) {
      var s = esc(t);
      return '<span class="cmsr__recent-chip">' +
        '<a class="cmsr__recent-link" href="' + esc(searchUrlFor(t)) + '" data-cmsr-term="' + s + '">' + s + '</a>' +
        '<button type="button" class="cmsr__recent-del" data-cmsr-recent-del="' + s + '" aria-label="' + s + ' 삭제">&times;</button>' +
        '</span>';
    }).join('');
  }

  /* ---------- 열기 / 닫기 ---------- */
  function positionDesktop() {
    var r = root();
    if (!r) return;
    if (!isDesktop()) {
      r.style.removeProperty('--cmsr-top');
      r.style.removeProperty('--cmsr-left');
      r.style.removeProperty('--cmsr-width');
      return;
    }
    // 헤더의 "원래 검색창"에 그대로 붙도록: 검색바 전체 박스를 기준으로 정렬
    var anchor = document.querySelector('.chdr__search') ||
                 document.querySelector('.search-bar__top') ||
                 document.querySelector('.search-bar__top-wrapper') ||
                 document.querySelector('.header__search-bar-wrapper .search-bar') ||
                 document.querySelector('.search-bar') ||
                 document.querySelector('.search-bar__input') ||
                 document.querySelector('[data-action="toggle-search"]');
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    if (!rect.width) return;
    var left = Math.max(8, rect.left);
    var top = Math.max(8, rect.bottom + 6);
    var width = Math.min(rect.width, window.innerWidth - left - 8);
    width = Math.max(width, 360);
    r.style.setProperty('--cmsr-top', top + 'px');
    r.style.setProperty('--cmsr-left', left + 'px');
    r.style.setProperty('--cmsr-width', width + 'px');
  }

  function open(prefill) {
    var r = root();
    if (!r || isOpen()) return;
    lastFocused = document.activeElement;
    positionDesktop();
    r.hidden = false;
    void r.getBoundingClientRect();
    r.classList.add('is-open');
    document.documentElement.classList.add('cmsr-open');

    renderRecent();
    var input = q('[data-cmsr-input]');
    if (input) {
      if (typeof prefill === 'string' && prefill) input.value = prefill;
      toggleClear();
      try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) {} }
      var l = input.value.length;
      try { input.setSelectionRange(l, l); } catch (e) {}
    }
    requestAnimationFrame(updateCatsNav);

    if (!openedByHistory && window.history && history.pushState) {
      try { history.pushState({ cmsr: 1 }, ''); openedByHistory = true; } catch (e) {}
    }
  }

  function finishClose() {
    var r = root();
    if (!r) return;
    r.hidden = true;
    closing = false;
  }

  function close(fromPop) {
    var r = root();
    if (!r || r.hidden || closing) return;
    closing = true;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('cmsr-open');

    var done = function () { r.removeEventListener('transitionend', done); finishClose(); };
    r.addEventListener('transitionend', done);
    setTimeout(done, 300);

    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
    }
    if (openedByHistory && !fromPop) {
      openedByHistory = false;
      if (history.state && history.state.cmsr) { try { history.back(); } catch (e) {} }
    } else {
      openedByHistory = false;
    }
  }

  window.addEventListener('popstate', function () { if (!root() || root().hidden) return; close(true); });

  /* ---------- 제출 ---------- */
  function submitTerm(term) {
    term = (term || '').trim();
    if (!term) { var i = q('[data-cmsr-input]'); if (i) i.focus(); return; }
    addRecent(term);
    window.location.href = searchUrlFor(term);
  }

  function toggleClear() {
    var input = q('[data-cmsr-input]');
    var clear = q('[data-cmsr-clear]');
    if (input && clear) clear.hidden = !input.value;
  }

  /* ---------- 포커스 트랩 ---------- */
  function trap(e) {
    if (e.key !== 'Tab' || !isOpen()) return;
    var panel = q('[data-cmsr-panel]');
    if (!panel) return;
    var nodes = panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
    var f = Array.prototype.filter.call(nodes, function (el) {
      return !el.hidden && el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- 빠른 카테고리: 좌우 이동 버튼 상태 ---------- */
  function catsEl() { return q('[data-cmsr-cats]'); }
  function updateCatsNav() {
    var r = root();
    var c = catsEl();
    if (!r || !c) return;
    var over = (c.scrollWidth - c.clientWidth) > 4;
    r.querySelectorAll('[data-cmsr-cats-nav]').forEach(function (b) {
      b.hidden = !over;
      if (over) {
        if (b.getAttribute('data-cmsr-cats-nav') === 'prev') b.disabled = c.scrollLeft <= 2;
        else b.disabled = c.scrollLeft >= (c.scrollWidth - c.clientWidth - 2);
      }
    });
  }

  /* ---------- 이벤트 (document 위임 → 섹션 리로드에도 안전) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 헤더 검색 트리거 → 레이어 열기 (기존 동작 차단)
    var trigger = t.closest('.search-bar__input, .search-bar__submit, [data-action="toggle-search"], [data-cmsr-open]');
    if (trigger && !t.closest('#cocomai-search-root')) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
      var form = trigger.closest('form');
      var native = form ? form.querySelector('.search-bar__input') : null;
      var val = (trigger.classList && trigger.classList.contains('search-bar__input')) ? trigger.value : (native ? native.value : '');
      if (native && native.blur) native.blur();
      open(val || undefined);
      return;
    }

    if (!root()) return;

    if (t.closest('[data-cmsr-close]')) { e.preventDefault(); close(); return; }

    if (t.closest('[data-cmsr-clear]')) {
      var inp = q('[data-cmsr-input]');
      if (inp) { inp.value = ''; toggleClear(); inp.focus(); }
      return;
    }

    if (t.closest('[data-cmsr-recent-clear]')) { clearRecent(); return; }

    var del = t.closest('[data-cmsr-recent-del]');
    if (del) { e.preventDefault(); removeRecent(del.getAttribute('data-cmsr-recent-del')); return; }

    var nav = t.closest('[data-cmsr-cats-nav]');
    if (nav && !nav.disabled) {
      var c = catsEl();
      if (c) {
        var dir = nav.getAttribute('data-cmsr-cats-nav') === 'prev' ? -1 : 1;
        c.scrollBy({ left: dir * Math.max(180, c.clientWidth * 0.6), behavior: 'smooth' });
      }
      return;
    }

    // 인기/추천/카테고리/최근 링크 클릭 → 검색어 기록 후 정상 이동
    var termLink = t.closest('[data-cmsr-term]');
    if (termLink && root().contains(termLink)) {
      addRecent(termLink.getAttribute('data-cmsr-term') || termLink.textContent);
      return;
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (isOpen()) return;
    var el = e.target;
    if (el && el.closest && el.closest('.search-bar__input') && !el.closest('#cocomai-search-root')) {
      var val = el.value || '';
      el.blur();
      open(val || undefined);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    trap(e);
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cmsr-input]')) toggleClear();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('[data-cmsr-form]')) {
      e.preventDefault();
      var inp = f.querySelector('[data-cmsr-input]');
      submitTerm(inp ? inp.value : '');
    }
  });

  /* 빠른 카테고리: 마우스 드래그 스크롤 */
  document.addEventListener('pointerdown', function (e) {
    var c = e.target && e.target.closest && e.target.closest('[data-cmsr-cats]');
    if (!c || !e.isPrimary || e.pointerType === 'touch') return;
    drag = { el: c, x: e.clientX, left: c.scrollLeft, moved: false, id: e.pointerId };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 3) { drag.moved = true; drag.el.classList.add('is-dragging'); }
    drag.el.scrollLeft = drag.left - dx;
  });
  function endDrag() {
    if (!drag) return;
    var el = drag.el, moved = drag.moved;
    el.classList.remove('is-dragging');
    if (moved) {
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      el.addEventListener('click', block, true);
      setTimeout(function () { el.removeEventListener('click', block, true); }, 60);
    }
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cmsr-cats]')) updateCatsNav();
  }, true);

  function onReflow() { if (isOpen()) { positionDesktop(); updateCatsNav(); } }
  window.addEventListener('resize', onReflow);
  window.addEventListener('scroll', onReflow, { passive: true });

  /* 테마 편집기 */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cocomai-search-root')) {
      renderRecent(); updateCatsNav();
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cocomai-search-root')) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cocomai-search-root')) close();
  });

  if (document.readyState !== 'loading') renderRecent();
  else document.addEventListener('DOMContentLoaded', renderRecent);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hotdeal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var EASE = 'transform 600ms cubic-bezier(0.22, 0.61, 0.36, 1)';

  function initRoot(marker) {
    var root = marker.closest('[id^="cocomai-limited-deals-"]');
    if (!root || root.dataset.ccInit === '1') return;
    root.dataset.ccInit = '1';

    var viewport = root.querySelector('[data-cc-viewport]');
    var track = root.querySelector('[data-cc-track]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = marker.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(marker.getAttribute('data-autoplay-speed'), 10) || 4500;

    if (n <= 1 || reduce) {
      track.style.transform = 'translateX(0)';
      return;
    }

    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[n - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);

    var index = 1;

    function setX(i, animate) {
      track.style.transition = animate ? EASE : 'none';
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
    }
    setX(index, false);

    function onEnd() {
      if (index >= n + 1) { index = 1; setX(index, false); }
      else if (index <= 0) { index = n; setX(index, false); }
    }
    track.addEventListener('transitionend', onEnd);

    function next() { index += 1; setX(index, true); }
    function prev() { index -= 1; setX(index, true); }

    var timer = null, visible = true, hover = false, touching = false;

    function playing() { return autoplay && visible && !hover && !touching; }
    function tick() { if (playing()) next(); }
    function start() { if (autoplay && !timer) timer = setInterval(tick, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function onEnter() { hover = true; }
    function onLeave() { hover = false; }
    viewport.addEventListener('mouseenter', onEnter);
    viewport.addEventListener('mouseleave', onLeave);

    var sx = 0, sy = 0, dx = 0, swiping = false;
    function ts(e) { touching = true; var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; swiping = false; }
    function tm(e) { var t = e.touches[0]; dx = t.clientX - sx; var dy = t.clientY - sy; if (Math.abs(dx) > Math.abs(dy)) swiping = true; }
    function te() { touching = false; if (swiping && Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); } }
    viewport.addEventListener('touchstart', ts, { passive: true });
    viewport.addEventListener('touchmove', tm, { passive: true });
    viewport.addEventListener('touchend', te);

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible = en.isIntersecting; });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    start();

    root._ccCleanup = function () {
      stop();
      if (io) io.disconnect();
      track.removeEventListener('transitionend', onEnd);
      viewport.removeEventListener('mouseenter', onEnter);
      viewport.removeEventListener('mouseleave', onLeave);
      viewport.removeEventListener('touchstart', ts);
      viewport.removeEventListener('touchmove', tm);
      viewport.removeEventListener('touchend', te);
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cc-deals]').forEach(initRoot);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[id^="cocomai-limited-deals-"]');
    if (root && root._ccCleanup) root._ccCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
